import script from "./productMiscellneous.vue?vue&type=script&lang=ts&setup=true"
export * from "./productMiscellneous.vue?vue&type=script&lang=ts&setup=true"

import "./productMiscellneous.vue?vue&type=style&index=0&id=2b2fcfa0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2fcfa0"]])

export default __exports__